import React from 'react'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { SafeAreaView, ScrollView } from 'react-native'
import { ItemContainer, TopContainer } from './Components'
import {
  ATLSpacing,
  ATLTextBody,
  ATLTextHead,
  SpacingSizesEnum,
  TextAlignmentEnum,
} from '@appsimples/atlantica-react-native'
import { CustomHeader } from '../../components/CustomHeader'

export const AnswerScreen: NavigationStackScreenComponent = navigation => {
  const { question, answer } = navigation?.route?.params

  return (
    <SafeAreaView>
      <ScrollView>
        <TopContainer>
          <ATLTextHead textAlignment={TextAlignmentEnum.left}>{question}</ATLTextHead>
        </TopContainer>

        <ItemContainer>
          <ATLTextBody labelBaseProps={{ multilineLimit: 100 }}>{answer}</ATLTextBody>
        </ItemContainer>
        <ATLSpacing type={SpacingSizesEnum.intersection} />
      </ScrollView>
    </SafeAreaView>
  )
}

AnswerScreen.navigationOptions = CustomHeader('')
